import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import './onboardingDialog.scss';

const OnboardingDialog = (): JSX.Element => {
    const { t } = useTranslation('browser');
    const [visible, setVisible] = useState(true);
    const [notShowAgain, setNotShowAgainValue] = useState(false);

    useEffect(() => {
        setVisible(!localStorage.getItem("sessionOnboardingDisabled"));
    }, []);

    const handleCloseDialog = () => {
        setVisible(false);
    }

    const onNotShowAgainChecked = (value: boolean) => {
        setNotShowAgainValue(value);
        localStorage.setItem('sessionOnboardingDisabled', 'true');
    }

    return <>
        {
            visible && <div className="onboarding-dialog-container">
            <div className="top-title">
                <div className="title">{ t('SESSION_ONBOARDING_TITLE') }</div>
                <img src="/media/light-close-icon.svg" alt="light close icon" onClick={ handleCloseDialog }/>
            </div>
            <div className="img-content">
                <img src="/media/session-onboarding.svg" alt="" />
                <span className="img-info">{ t('SESSION_TOP_BANNER_TITLE') }</span>
            </div>
            <div className="info-content">{ t('SESSION_ONBOARDING_INFO') }</div>
            <div className="operations">
                <button
                    className="button submit-btn login-button ctx-button"
                    onClick={ handleCloseDialog }>
                        {t('SESSION_ONBOARDING_BUTTON')}
                </button>
                <div>
                    <input type="checkbox" id="donotShow" checked={ notShowAgain } onChange={ e => onNotShowAgainChecked(e.target.checked) } />
                    <label htmlFor="donotShow">{ t('SESSION_ONBOARDING_NOT_SHOW') }</label>
                </div>
            </div>
        </div>
        }
    </>
}

export default OnboardingDialog;